<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69.03 69.03"><path d="M6 46.2v17.32h57V46.2zm34.1 6v5.32H29.2V52.2zm-28.1 0h11.2v5.32H12zm45 5.32H46.13V52.2h10.93zm-8.93-37.45L51 17.15l4.24 4.24-2.92 2.92zm3.58-3.57 2.92-2.92 4.24 4.24-2.92 2.92zm-4.28 4.28L34.31 33.84 22.54 22.08 7.66 36.97l4.24 4.24 10.64-10.64 11.77 11.76 17.31-17.31z"/></svg>
</template>
